import React, {Component} from "react";
import {Button, Col, Form, FormControl, Modal, Row} from "react-bootstrap";
import Axios from "axios";
import MultipleImagesPng from "./multipleimages.png";

export default class UploadImagesModal extends Component {

    state = {
        uploadProgress: 0,
        totalFiles: 0,
        successfulUploads:[] ,
        failedUploads:[],
    }

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;

        if (form["boardImg"] && form["boardImg"].files && form["boardImg"].files.length) {
            this.setState({
                totalFiles: form["boardImg"].files.length,
                loading: true,
                successfulUploads: [],
                failedUploads: [],
                uploadProgress:0,
            });

            const uploadPromises = [];

            for (let img of form["boardImg"].files) {
                let data = new FormData();
                data.append("boardImg", img);
                let unitNumber = img.name.replace(".png", "").replace(".jpg", "").replace(".jpeg", "").replace(".pdf", "");
                data.append("boardId", unitNumber);
                data.append("campaignId", this.props.campaignId ? this.props.campaignId : "");

                const uploadPromise = Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/edit-image", data, {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.setState(prevState => ({
                        uploadProgress: prevState.uploadProgress + 1,
                        successfulUploads: [...prevState.successfulUploads, unitNumber]// Increment success counter
                    }));
                    return response;
                }).catch(error => {
                    this.setState(prevState => ({
                        uploadProgress: prevState.uploadProgress + 1,
                        failedUploads: [...prevState.failedUploads, `${unitNumber}`]// Increment success counter

                    }));
                    console.log(error)
                    console.log(error.message);
                    console.log(error.response);
                    return error;
                });

                uploadPromises.push(uploadPromise);
            }

            Promise.all(uploadPromises)
                .then(() => {
                    const { successfulUploads, failedUploads, totalFiles } = this.state;
                    this.props.handleImageChange(<>{successfulUploads.length} out of {totalFiles} images uploaded successfully. {failedUploads.length} failed.
                        <br/>
                        Failed Uploads: {failedUploads.map(unitNumber=><>{unitNumber}; </>)}
                    </>);
                })
                .catch(error => {
                    console.log(error.message);
                    console.log(error.response);
                    const { successfulUploads, failedUploads, totalFiles } = this.state;
                    this.props.handleImageChange(<>
                        Upload completed with {successfulUploads.length} successes and {failedUploads.length} failures out of {totalFiles} files.
                        <br/>
                        Failed Uploads: {failedUploads.map(unitNumber=><>{unitNumber}; </>)}
                    </>);
                });
        }
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Form onSubmit={this.onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>+ Upload Images</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Upload multiple image files. Do not upload a .zip or a folder.<br/>Example:
                    <img className={"d-block"} style={{width:200}} src={MultipleImagesPng} alt={"How to select multiple images"}/>
                    <Row className={"mt-4"}>
                        <Col className={"text-center col-6 mt-1"}>
                            <FormControl type="file" name="boardImg" accept={"image/*,.pdf"} multiple="multiple"/>
                        </Col>
                    </Row>
                    {this.state.totalFiles && (<Row className={"mt-4"}>
                        <Col className={"text-center col-6 mt-1"}>
                            {this.state.uploadProgress}/{this.state.totalFiles} Uploaded
                        </Col>
                    </Row>)}
                </Modal.Body>
                <Modal.Footer>
                    <span onClick={this.props.onHide} className={"mr-4 boring-btn"}>Close</span>
                    <Button variant="primary" type="submit">
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    }
}
